const miniCart = () => {
  // Local Variables
  const miniCartDrawer = $('.mrMiniCart-drawer');

  // Function definitions
  // --------------------------------------------------------------------------------

  function setupClickedOutsideMiniCart() {
    // watch clocks on the body element
    $('body').on('click', function (event) {
      // Check if minicart drawer is open - if not, do nothing
      if (!miniCartDrawer.hasClass('active')) return;
      // Check if clicked are is closer to the mini cart drawer or the body
      if ($(event.target).closest('#CartDrawer').length <= 0) {
        closeMiniCartDrawer();
      }
    });
  }

  /**
   * Close Mini Cart
   * by clicking the close button
   *
   * @param {obj} closeButton
   * @returns void
   */
  function closeMiniCartDrawer() {
    $('body').removeClass('overflow-hidden');
    miniCartDrawer.removeClass('active').removeClass('animate');
  }

  /** function for mobile safari toolbar covering checkout button */
  function forMobileSafariBottomBar() {
    new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        // const windowFullHeight = parseFloat(window.outerHeight);
        document.documentElement.style.setProperty(
          '--webkit-footer-gap',
          `${entry.contentRect.height}px`,
        );
      });
    }).observe(document.querySelector('.webkit-gap'));
  }

  function updateFreeShippingMessage() {
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success(cart) {
        const freeShippingThreshold = $('.mrMiniCart-freeShipping').data('shipping-threshold');
        const awayFromDelivery = (freeShippingThreshold - cart.total_price) / 100;
        const shippingMsg = $('[id=shipping-msg]');
        const qualifiedMsg = $('[id=shipping-qualified-msg]');

        if (cart.total_price < freeShippingThreshold) {
          shippingMsg.find('span').text(`you are $${awayFromDelivery.toFixed(2)} away from free delivery!`);
          shippingMsg.show();
          qualifiedMsg.hide();
        } else {
          shippingMsg.hide();
          qualifiedMsg.show();
        }
      },
    });
  }
  $(window).on('cart:quantity-update', function () {
    updateFreeShippingMessage();
  });

  function removeImage() {
    const $miniCartItems = $('.mrMiniCart-item');
    const itemLength = $miniCartItems.length;

    if (itemLength >= 2) {
      $miniCartItems.each(function (index) {
        $(this).addClass(`item-${index + 1}`);
      });

      if ($(window).width() < 1024) {
        $('.mrMiniCart-items').css('max-height', 'calc(100vh - 460px)');
      } else {
        $('.mrMiniCart-items').css('max-height', 'calc(100vh - 390px)');
      }
    } else {
      $miniCartItems.removeClass(function (index) {
        return `item-${index + 1}`;
      });
    }
  }
  removeImage();

  let prevItemLength = $('.mrMiniCart-item').length;
  // auto refresh
  setInterval(function () {
    const newLength = $('.mrMiniCart-item').length;
    prevItemLength = newLength;
    removeImage();
  }, 1000);

  // internal functions call from here...
  // --------------------------------------------------------------------------------
  setupClickedOutsideMiniCart();
  forMobileSafariBottomBar();
};

export default miniCart;
